"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../redux/selectors"));

var _user = require("../redux/user/user.types");

var _LandingPage = _interopRequireDefault(require("../pages/auth/LandingPage"));

var _AdminRouter = _interopRequireDefault(require("./AdminRouter"));

var _StudyRouter = _interopRequireDefault(require("./StudyRouter"));

var _clientWebsocketManager = _interopRequireDefault(require("../redux/clientWebsocketManager"));

var _GitInfo = _interopRequireDefault(require("../GitInfo"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Router extends _react.default.Component {
  componentDidMount() {
    const {
      authenticatedUserId,
      user,
      getUser
    } = this.props;

    if (authenticatedUserId && !user) {
      getUser(authenticatedUserId);

      _clientWebsocketManager.default.createConnection();
    }
  }

  render() {
    const {
      userLoadingStatus,
      user
    } = this.props;

    if (userLoadingStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading...");
    }

    if (userLoadingStatus.isError) {
      if (userLoadingStatus.errorStatus === 403) {
        return /*#__PURE__*/_react.default.createElement("div", null, "Forbidden");
      }

      return /*#__PURE__*/_react.default.createElement("div", null, "Error");
    }

    if (!user) {
      return /*#__PURE__*/_react.default.createElement("div", null, "The user could not be loaded.");
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/admin",
      component: _AdminRouter.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/study",
      component: _StudyRouter.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/gitInfo",
      component: _GitInfo.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      component: _LandingPage.default
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  authenticatedUserId: selectors.getAuthenticatedUserId,
  userLoadingStatus: selectors.getUserLoadingStatus,
  user: selectors.getUser
});

const mapDispatchToProps = dispatch => {
  return {
    getUser: id => dispatch(_user.getUserAsync.request(id))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Router);

exports.default = _default;